<script>import { isDateValid, parseDateISO } from "../../../utils/date";
import SVG from "../../elements/SVG.svelte";
import { attrValue } from "../../../utils/html";
import { undefOrNull } from "../../../utils/objects";
import DynamicComponent from "../DynamicComponent.svelte";
import { viewport } from "../../../stores";
import TabletSwipeableWrapper from "../TabletSwipeableWrapper.svelte";
import { formatAmountWithCurrency } from "../../../utils/strings";
import { onMount } from "svelte";
import Hint from "../../elements/Hint.svelte";
import FilterControls from "./FilterControls.svelte";
import { buildFilters } from "../../../utils/table";
import { stickyAction } from "../../../actions";
import ButtonBoxTextColor from "../../elements/buttons/variants/ButtonBoxTextColor.svelte";
import { Pagination } from "../../..";
export let props = {
  headers: {
    data: []
  },
  data: []
};
export let withRowsBorder = false;
export let withLoadMoreActions = false;
export let initialNumberDisplay = 20;
export let withSearch = false;
export let columnIndexToSearch = 0;
export let searchPlaceholder = "";
export let sticky = false;
export let top = void 0;
export let pagination = void 0;
export let paginationDesc = void 0;
export let handlePaginationChange = void 0;
let originalPropsData;
let filters;
let searchProps = {
  placeholder: searchPlaceholder
};
let showLoadMoreButton = withLoadMoreActions && props?.data && initialNumberDisplay < props.data.length;
let showLoadLessButton = false;
let isStuck = false;
function handleStuck(e) {
  isStuck = e.detail.isStuck;
}
const onPaginationChange = (e) => {
  handlePaginationChange && handlePaginationChange(e);
};
const initSortOptions = () => {
  const defaultSortedIndex = props.headers?.data.findIndex((e) => e?.isDefaultKey) ?? void 0;
  return {
    sortColIndex: defaultSortedIndex != void 0 && defaultSortedIndex >= 0 ? defaultSortedIndex : null,
    dir: defaultSortedIndex && props.headers?.data[defaultSortedIndex]?.dir ? props.headers?.data[defaultSortedIndex]?.dir : "desc"
  };
};
const resetFilters = () => {
  activeFiltersValues = [];
  hideLines();
  filters = filters.map((f) => {
    if (f) {
      f.value = void 0;
    }
    return f;
  });
};
$: if (searchProps.value && originalPropsData) {
  filters && resetFilters();
  props.data = originalPropsData.filter(
    (e) => e?.cells[columnIndexToSearch]?.data?.value.toString().toLowerCase().includes(searchProps.value.toString().toLowerCase())
  );
  props.data.forEach((e) => {
    e.isHidden = false;
    e.isHiddenWithLoadMore = false;
  });
  if (props.footer) {
    props.footer[0].isHidden = true;
  }
} else if (!searchProps.value && originalPropsData) {
  props.data = originalPropsData;
  props.footer && (props.footer[0].isHidden = false);
}
let footer = [];
$: footer = props.footer ?? [];
let sortOptions = initSortOptions();
const getNextDir = () => {
  switch (sortOptions.dir) {
    case "asc":
      return "desc";
    case "desc":
    default:
      return "asc";
  }
};
const compareValues = (v1, v2, dir) => {
  if (typeof v1 == "string" && isDateValid(v1) && typeof v2 == "string" && isDateValid(v2)) {
    v1 = parseDateISO(v1).getTime();
    v2 = parseDateISO(v2).getTime();
  }
  if (undefOrNull(v1)) {
    return 1;
  } else if (undefOrNull(v2)) {
    return -1;
  }
  if (dir === "asc") {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  } else if (dir === "desc") {
    return v1 > v2 ? -1 : v1 < v2 ? 1 : 0;
  } else {
    return 0;
  }
};
const updateTableWithLoadMoreAction = (numberOfLinesToDisplay) => {
  props.data = props?.data?.map((line, index) => {
    line.isHiddenWithLoadMore = index + 1 > numberOfLinesToDisplay;
    return line;
  });
  updateSum();
  filters = buildFilters(props);
};
const loadAll = () => {
  showLoadMoreButton = false;
  showLoadLessButton = true;
  updateTableWithLoadMoreAction(props.data?.length ?? 0);
};
const loadLess = () => {
  showLoadMoreButton = true;
  showLoadLessButton = false;
  updateTableWithLoadMoreAction(initialNumberDisplay);
};
const sortTable = () => {
  sortOptions.sortColIndex !== null && (props.data = props.data?.sort(
    (a, b) => compareValues(
      a.cells[sortOptions.sortColIndex].data.value,
      b.cells[sortOptions.sortColIndex].data.value,
      sortOptions.dir
    )
  ) ?? []);
};
if (sortOptions.sortColIndex !== null) {
  sortTable();
}
let activeFiltersValues = [];
const hideLines = () => {
  props.data?.forEach((row) => {
    let numberOfCellValueMatchingActiveFiltersValues = 0;
    activeFiltersValues.forEach((f) => {
      if (row.cells[f.index]?.data.value === f.value) {
        numberOfCellValueMatchingActiveFiltersValues++;
      }
    });
    row.isHidden = numberOfCellValueMatchingActiveFiltersValues !== activeFiltersValues.length;
  });
};
const updateSum = () => {
  let sumOfSpans = 0;
  props.footer && props.footer[0].cells.forEach((c, i) => {
    if (c) {
      if (typeof c.data.display == "string" && c.data.display.includes("\u20AC")) {
        let totalValue = props.data?.map((row) => {
          return !row.isHidden && !row.isHiddenWithLoadMore ? row.cells[sumOfSpans]?.data.value : 0;
        }).reduce((prev, next) => prev + next);
        (totalValue || totalValue === 0) && (c.data.display = formatAmountWithCurrency(totalValue));
        applyColorIndicator(i, c, totalValue);
        sumOfSpans++;
      } else {
        if (c.span) {
          sumOfSpans = sumOfSpans + c.span;
        } else {
          sumOfSpans++;
        }
      }
    }
  });
};
const filterTable = (f, i) => {
  let currentFilterValue;
  currentFilterValue = f.value;
  if (currentFilterValue !== void 0) {
    if (!activeFiltersValues.length) {
      activeFiltersValues.push({ index: i, value: currentFilterValue });
    } else {
      let currentActivatedFilter = activeFiltersValues.find((f2) => f2.index === i);
      if (currentActivatedFilter) {
        currentActivatedFilter.value = currentFilterValue;
      } else {
        activeFiltersValues.push({ index: i, value: currentFilterValue });
      }
    }
  } else {
    activeFiltersValues = activeFiltersValues.filter((e) => e.index !== i);
  }
  hideLines();
  updateSum();
  props.footer = props.footer;
  props.data = props.data;
};
const applyColorIndicator = (i, c, totalValue) => {
  if (i !== 1 && c.colorIndicator && (totalValue || totalValue === 0)) {
    c.classNames = `${totalValue > 0 ? "text-success" : "text-danger"} font-semibold`;
  }
};
onMount(() => {
  if (withLoadMoreActions) {
    updateTableWithLoadMoreAction(initialNumberDisplay);
  } else {
    filters = buildFilters(props);
  }
  originalPropsData = props.data;
});
$: onSortClick = (index) => {
  if (sortOptions.sortColIndex !== index) {
    sortOptions = {
      sortColIndex: index,
      dir: "asc"
    };
  } else {
    sortOptions = {
      ...sortOptions,
      dir: getNextDir()
    };
  }
  sortTable();
};
$: isSortOn = (index) => {
  return index === sortOptions.sortColIndex;
};
</script>

{#if filters?.filter((f) => f !== undefined).length || withSearch}
	<FilterControls
		bind:searchProps
		{filters}
		onClickSelect={filterTable}
		{columnIndexToSearch}
		{withSearch}
	/>
{/if}
<TabletSwipeableWrapper classNames="!snap-none">
	<table id={props.id} class={`lg:table-fixed ${props.classNames}`} bind:this={props.ref}>
		{#if props.headers.data}
			<thead>
				<tr class={props.headers.classNames}>
					{#each props.headers.data as header, index}
						{#if header && ((header.isMobile && $viewport.isMobile) || !$viewport.isMobile)}
							<th
								class={header.classNames}
								colspan={header.span ?? 1}
								class:sticky-cell={sticky}
								class:bordered-rows={withRowsBorder}
								style={sticky && top
									? `--sticky-top: ${top[0]}px; --sticky-top-md: ${top[1]}px; --sticky-top-lg: ${top[2]}px; --sticky-top-xl: ${top[3]}px; --sticky-top-2xl: ${top[4]}px`
									: ''}
							>
								<div
									class="inline-flex items-center {isSortOn(index)
										? 'text-secondary'
										: 'text-grey-dark'} font-medium"
								>
									{#if header.label}
										<span class="first-letter:uppercase">{@html header.label}</span>
									{/if}
									{#if header.tooltipTitle}
										<Hint tooltip={{ title: header.tooltipTitle }} />
									{/if}
									{#if header.label && header.sortable && props.data && props.data.length > 1}
										<SVG
											name="arrow_down_square"
											size="small"
											classNames={attrValue([
												'ml-3 cursor-pointer',
												isSortOn(index) && sortOptions.dir === 'asc' ? 'transform rotate-180' : ''
											])}
											on:click={() => onSortClick(index)}
										/>
									{/if}
								</div>
							</th>
						{/if}
					{/each}
				</tr>
			</thead>
		{/if}
		<tbody>
			{#if props.data}
				{#each props.data as row}
					<tr
						class={attrValue([row.classNames, row.onClick ? 'cursor-pointer' : ''])}
						class:hidden={row.isHidden || row.isHiddenWithLoadMore}
						on:click={() => {
							if (row.onClick) row.onClick();
						}}
					>
						{#each row.cells as cell, index}
							{#if cell && ((props.headers?.data[index]?.isMobile && $viewport.isMobile) || !$viewport.isMobile)}
								<td
									class={attrValue([cell.classNames])}
									class:td-bordered={withRowsBorder}
									colspan={cell.span ?? 1}
								>
									{#if cell.data.display || typeof cell.data.display === 'boolean'}
										{#if typeof cell.data.display == 'string'}
											{@html cell.data.display}
										{:else if typeof cell.data.display == 'boolean'}
											<SVG
												name={cell.data.display ? 'check_circle' : 'close_circle'}
												classNames={cell.data.display ? 'text-success' : 'text-error'}
											/>
										{:else if typeof cell.data.display == 'object'}
											<DynamicComponent component={cell.data.display} />
										{/if}
									{:else if typeof cell.data.value == 'string' || typeof cell.data.value == 'number'}
										{cell.data.value}
									{/if}
								</td>
							{/if}
						{/each}
					</tr>
				{/each}
			{/if}
			{#each footer as row}
				<tr
					class={attrValue([
						'mx-4 footer-row bg-grey-lighter h-[60px] relative',
						row.isSticky && 'sticky bottom-1',
						row.classNames
					])}
					use:stickyAction={{ earlyReturn: !row.isSticky, stickToTop: false }}
					on:stuck={handleStuck}
					class:isStuck
					class:hidden={row.isHidden}
				>
					{#each row.cells as cell, index}
						{#if cell && ((props.headers?.data[index]?.isMobile && $viewport.isMobile) || !$viewport.isMobile)}
							<td
								class={attrValue([cell.classNames])}
								colspan={cell.span ?? 1}
							>
								{#if cell.data.display}
									{#if typeof cell.data.display == 'string'}
										<div class="first-letter:uppercase inline-block">{@html cell.data.display}</div>
									{:else if typeof cell.data.display === 'boolean'}
										<SVG
											name={cell.data.display ? 'check_circle' : 'close_circle'}
											classNames={cell.data.display ? 'text-success' : 'text-error'}
										/>
									{:else if typeof cell.data.display == 'object'}
										<DynamicComponent component={cell.data.display} />
									{/if}
								{:else if typeof cell.data.value == 'string' || typeof cell.data.value == 'number'}
									<span class="first-letter:uppercase"> {cell.data.value}</span>
								{:else if typeof cell.data.value == 'boolean'}
									<SVG name={cell.data.value ? 'check' : 'cross'} />
								{/if}
								{#if index === 0 && showLoadMoreButton}
									<span class="text-sm">{`(sur ${initialNumberDisplay} lignes)`}</span>
								{/if}
							</td>
						{/if}
					{/each}
				</tr>
			{/each}
		</tbody>
	</table>
</TabletSwipeableWrapper>

{#if !searchProps.value}
	{#if showLoadMoreButton}
		<div class="flex justify-center mt-4 pb-4">
			<ButtonBoxTextColor
				props={{
					label: props.loadAllLabel,
					classNames: 'inline-flex'
				}}
				on:click={() => loadAll()}
			/>
		</div>
	{/if}
	{#if showLoadLessButton}
		<div class="flex justify-center mt-4 pb-4">
			<ButtonBoxTextColor
				props={{
					label: props.loadLessLabel,
					classNames: 'inline-flex'
				}}
				on:click={() => loadLess()}
			/>
		</div>
	{/if}
{/if}

{#if pagination}
	<Pagination data={pagination} desc={paginationDesc} on:load={onPaginationChange} />
{/if}

<style>table{border-collapse:separate;border-spacing:0 .5rem;width:100%}table :global(.hiddenInTableCell){display:none}table :global(.tag){font-size:.875rem!important;line-height:1.25rem!important}td{padding-bottom:.5rem;padding-top:.5rem;text-align:center}@media (min-width:1024px){td{font-size:.875rem;line-height:1.25rem;padding-bottom:.25rem;padding-top:.25rem}}@media (min-width:1536px){td{font-size:1rem;line-height:1.5rem;padding-bottom:.5rem;padding-top:.5rem}}td.td-bordered,td:not(.td-bordered)+td,th:not(.bordered-rows)+th{padding-left:1rem}td.td-bordered{padding-right:1rem}@media (min-width:1024px){td.td-bordered{padding-left:.5rem;padding-right:.5rem}}@media (min-width:1536px){td.td-bordered{padding-left:1rem;padding-right:1rem}}th{padding-bottom:1rem;text-align:center;z-index:1}@media (min-width:1024px){th{font-size:.875rem;line-height:1.25rem}}@media (min-width:1536px){th{font-size:1rem;line-height:1.5rem}}th.bordered-rows{padding-left:1rem;padding-right:1rem}@media (min-width:1024px){th.bordered-rows{padding-left:.5rem;padding-right:.5rem}}@media (min-width:1536px){th.bordered-rows{padding-left:1rem;padding-right:1rem}}.td-bordered{border-bottom-width:1px;border-top-width:1px;--tw-border-opacity:1;border-color:#c4c4c4;border-color:rgba(196,196,196,var(--tw-border-opacity,1))}.td-bordered:first-child{border-left-width:1px}.td-bordered:last-child{border-right-width:1px}.td-bordered:first-child{border-bottom-left-radius:.5rem;border-top-left-radius:.5rem}.td-bordered:last-child{border-bottom-right-radius:.5rem;border-top-right-radius:.5rem}td:first-child,th:first-child{text-align:left}tr:not(.footer-row):hover{position:relative}.footer-row td:first-child:before,tr:hover td:not(.td-bordered):first-child:before{border-bottom-left-radius:.5rem;border-top-left-radius:.5rem;left:-.5rem}.footer-row td:first-child:before,.footer-row td:last-child:before,tr:hover td:not(.td-bordered):first-child:before,tr:hover td:not(.td-bordered):last-child:before{content:var(--tw-content);display:block;height:100%;position:absolute;top:0;width:.5rem;--tw-bg-opacity:1;background-color:#f7f7f7;background-color:rgba(247,247,247,var(--tw-bg-opacity,1))}.footer-row td:last-child:before,tr:hover td:not(.td-bordered):last-child:before{border-bottom-right-radius:.5rem;border-top-right-radius:.5rem;right:-.5rem}.footer-row.isStuck{box-shadow:0 7px 15px 15px #e6e6e6;z-index:10}td:last-child,th:last-child{text-align:right}.sticky-cell{z-index:9;--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity,1));position:sticky;top:var(--sticky-top)}@media (min-width:768px){.sticky-cell{top:var(--sticky-top-md)}}@media (min-width:1024px){.sticky-cell{top:var(--sticky-top-lg)}}@media (min-width:1280px){.sticky-cell{top:var(--sticky-top-xl)}}@media (min-width:1536px){.sticky-cell{top:var(--sticky-top-2xl)}}tbody tr:hover{--tw-bg-opacity:1;background-color:#f7f7f7;background-color:rgba(247,247,247,var(--tw-bg-opacity,1))}</style>
